import React from "react";

import CircularProgress from '@mui/material/CircularProgress';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import {CxGrid} from "./CxGrid";

const POSITION = {
    topLeft     : { vertical: 'top',    horizontal: 'left' },
    topCenter   : { vertical: 'top',    horizontal: 'center' },
    topRight    : { vertical: 'top',    horizontal: 'right' },
    bottomLeft  : { vertical: 'bottom', horizontal: 'left' },
    bottomCenter: { vertical: 'bottom', horizontal: 'center' },
    bottomRight : { vertical: 'bottom', horizontal: 'right' }
};

const SEVERITY = {
    info        : { name: 'info',       title: 'Information'},
    success     : { name: 'success',    title: 'Erfolg'},
    warning     : { name: 'warning',    title: 'Warnung'},
    error       : { name: 'error',      title: 'Fehler'}
};

export function CxRunning() {
    return (
        <Box sx={{ display:"flex", justifyContent:"center", p:2}}>
            <CircularProgress />
        </Box>
    );
}

export function CxWaiting() {
    return (
        <Backdrop
            open={true}
            onClick={() => {}}
            sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
            <Box sx={{ display:"flex", justifyContent:"center", p:2}}>
                <CircularProgress />
            </Box>
        </Backdrop>
    );
}

export function CxAlert({ severity, message }) {
    const { name, title } = SEVERITY[severity] || SEVERITY.info;

    return (
        <Alert severity={name} variant="outlined" sx={{ bgcolor: 'background.paper' }}>
            <AlertTitle>{title}</AlertTitle>
            {message}
        </Alert>
    );
}

export function CxError({message}) {
    return <CxAlert severity="error" message={message} />;
}

export function CxSnack({ message, handleClose, position = "topRight", key = "snack" }) {
    const anchor = POSITION[position] || POSITION.topRight;

    const renderAction = () => {
        return(
            <IconButton size="small" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
            </IconButton>
        );
    }

    return (
        <Snackbar
            anchorOrigin={anchor}
            message={message}
            open={Boolean(message)}
            onClose={handleClose}
            key={key}
            action={renderAction()}
        />
    );
}

export const CxListFeedback = ({call}) => {
    const message = `Fehler beim Laden der Daten: ${call.result}`;
    return (
        <CxGrid size="xl">
            { call.isRunning && <CxRunning /> }
            { call.isError   && <CxAlert severity="error" message={message} /> }
        </CxGrid>
    );
}


export const CxFormFeedback = ({ call, prefix = "Fehler bei der ausgeführten Aktion:" }) => {
    const message = `${prefix} ${call.result}`;

    return (
        <CxGrid size="xl">
            {call.isRunning && <CxWaiting />}
            {call.isError && <CxAlert severity="error" message={message} />}
        </CxGrid>
    );
};
